import * as S from "./styles";
import {
  faFileDownload,
  faPlusCircle,
  faTable
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useIONEngagedPage from "./useIONEgagedPage";
import { Loading } from "../../components/Loading";
import { FieldList } from "../../components/FieldList/index";
import AccordionPanel from "../../components/Accordion";
import { Modal } from "../../components/Modal";
import { DialogYesNoCancel } from "../../components/DialogYesNoCancel";

export const IONEngagedPage = ({ access }) => {
  const {
    ACCORDION_METADATA,
    loading,
    disabledApplyBTN,
    handleApplyBTN,
    downloadTemplateCargarGastosComprometidos,
    businessSelected,
    businessUnitList,
    handleChangeListInput,
    areaSelected,
    areaList,
    exerciseList,
    exerciseSelected,
    loadListSection,
    visibleModal,
    visibleAlert,
    messageAlert,
    selected,
    comprometido,
    setComprometido,
    deleteComprometido,
    editComprometido,
    addComprometido,
    listsModalComprometido,
    cerrarModal,
    cerrarModalAlert,
    metadataTable,
    setMetadataTable,  
    procesarSeleccion
  } = useIONEngagedPage({ access });

  const handleNavigateToGlosario = () => {
    window.open('/glosario_partidas', "_blank");
  };

  const mensajeEditar =
    !comprometido || comprometido?.PermiteEditar
      ? "Datos del comprometido"
      : comprometido?.PermiteEditarImporteBaja
      ? "Solo se permite editar el campo importe a la baja"
      : "No se permite editar el comprometido";
  return (
    <>
      {visibleModal === "visualizarComprometido" && (
        <Modal
          type="visualizarComprometido"
          title="Datos del comprometido"
          message="Visualizacion de datos del comprometido"
          labelConfirm="Volver"
          values={comprometido}
          cancel={cerrarModal}
          lists={listsModalComprometido}
          area={areaSelected}
          metadataTable={metadataTable}
          setMetadataTable={setMetadataTable}
        />
      )}
      {visibleModal === "eliminarComprometido" && (
        <Modal
          type="eliminarComprometido"
          title="Eliminar Comprometido"
          message="¿Estás seguro de que quieres eliminar el comprometido?"
          labelConfirm="Eliminar"
          values={{ selected }}
          confirm={() => deleteComprometido(selected)}
          cancel={cerrarModal}
          lists={listsModalComprometido}
          area={areaSelected}
        />
      )}
      {visibleModal === "cargarComprometido" && (
        <Modal
          type="cargarComprometido"
          title="Cargar Comprometido"
          message="Datos del nuevo comprometido"
          labelConfirm="Añadir"
          values={{}}
          setValues={setComprometido}
          confirm={() => addComprometido(comprometido)}
          cancel={cerrarModal}
          lists={listsModalComprometido}
          area={areaSelected}
          metadataTable={metadataTable}
          setMetadataTable={setMetadataTable}
        />
      )}
      {visibleModal === "editarComprometido" && comprometido && (
        <Modal
          type="editarComprometido"
          title="Editar Comprometido"
          message={mensajeEditar}
          labelConfirm="Guardar"
          values={comprometido}
          setValues={setComprometido}
          confirm={() => editComprometido(comprometido)}
          cancel={cerrarModal}
          lists={listsModalComprometido}
          area={areaSelected}
          metadataTable={metadataTable}
          setMetadataTable={setMetadataTable}
        />
      )}
      {visibleAlert !== "" && ( 
        <DialogYesNoCancel message={"Desea procesar los registros seleccionados?"}  message2={messageAlert} showNo={true} yesEvent={procesarSeleccion} noEvent={cerrarModalAlert} />
      )}
      <S.IONEngagedPageContent>
        <Loading hidden={!loading} />
        <S.Filters count={4}>
          <FieldList
            id="businessUnitSelect"
            type="enum"
            canBeEmpty={true}
            currentOption={businessSelected || {}}
            options={businessUnitList}
            handleChange={(id, value) =>
              handleChangeListInput(id, value.Valor, value.Etiqueta)
            }
            label="Unidad de Negocio"
          />

          <FieldList
            id="areaSelect"
            type="enum"
            canBeEmpty={true}
            currentOption={areaSelected || {}}
            options={areaList}
            handleChange={(id, value) =>
              handleChangeListInput(id, value.Valor, value.Etiqueta)
            }
            label="Área"
            isDisabled={areaList.length === 0 ? true : false}
          />

          <FieldList
            id="exerciseSelect"
            type="enum"
            canBeEmpty={true}
            currentOption={exerciseSelected || {}}
            options={exerciseList}
            handleChange={(id, value) =>
              handleChangeListInput(id, value.Valor, value.Etiqueta)
            }
            label="Ejercicio"
            isDisabled={exerciseList.length === 0 ? true : false}
          />

          <S.Buttons>
            <button
              id="applyBtn"
              disabled={disabledApplyBTN}
              onClick={handleApplyBTN}
            >
              <FontAwesomeIcon icon={faPlusCircle} size="lg" />
              Aplicar
            </button>
            <button
              id="loadTemplateBtn"
              onClick={downloadTemplateCargarGastosComprometidos}
            >
              <FontAwesomeIcon icon={faFileDownload} size="lg" />
              Plantilla Cargar Gastos
            </button>
            <button
              id="navigateGlosarioBtn"
              onClick={handleNavigateToGlosario}
            >
              <FontAwesomeIcon icon={faTable} size="lg" />
              Glosario
            </button>
          </S.Buttons>
        </S.Filters>

        {ACCORDION_METADATA.map((section, index) => (
          <AccordionPanel
            key={index}
            label={section.label}
            content={section.content}
            access={section.access}
            openAction={
              section.label === "Listado" ? loadListSection : () => {}
            }
          />
        ))}
      </S.IONEngagedPageContent>
    </>
  );
};
